import { render } from "./TheFooter.vue?vue&type=template&id=4a2acd88&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=4a2acd88&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aurel\\Desktop\\new-website\\portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2acd88"]])

export default __exports__